// A club's own sign-up link, /join/<name>. The link decides the club: the
// page shows which club it is and the account joins that club.
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
// The shared client: it knows the API's address before any page effect runs
import { get } from '../utils/apiInterceptor';
import Register from './Register';
import { bookingTokens } from '../contexts/BrandingContext';
import './booking/bookingVars.css';
import './AuthPages.css';

export default function Join() {
  const { name } = useParams();
  const [club, setClub] = useState(null);
  const [problem, setProblem] = useState(null);

  useEffect(() => {
    let live = true;
    get(`/api/public/join/${encodeURIComponent(name)}`)
      .then(r => { if (live) setClub(r.data); })
      .catch(err => {
        if (live) setProblem(err.response?.status === 404 ? "We couldn't find that club. Check the link with the club." : "Something went wrong. Please try again.");
      });
    return () => { live = false; };
  }, [name]);

  if (club?.open) return <Register club={club} />;
  if (!club && !problem) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div className="auth-page" style={club?.accentColor ? bookingTokens({ secondaryColor: club.accentColor }) : undefined}>
      <div className="auth-card">
        {club && <div className="auth-brand">{club.name}</div>}
        <h1 className="auth-heading">{club ? 'Not taking sign-ups online' : 'Club not found'}</h1>
        <p className="auth-hint">{club ? `${club.name} isn't taking sign-ups online at the moment. Please ask the club.` : problem}</p>
        <div className="auth-links">
          <Link to="/login" className="auth-link">Already have an account? Sign in</Link>
        </div>
      </div>
    </div>
  );
}
